"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
var Action;
(function (Action) {
    Action["INITIALIZE"] = "APP::CLIENT::INITIALIZE";
})(Action = exports.Action || (exports.Action = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@shopify/app-bridge-core/actions/Client/index.js
// module id = 51h+
// module chunks = 0